export default "__VITE_ASSET__j5c7hWlc__"